"use client";

import { useState } from "react";
import OKGoalOddEvenOdds from "../OKGoalOddEvenOdds";
import OKTotalCornersOdds from "../OKTotalCornersOdds";
import OkCorrectScoresOdds from "../OKCorrectScoresOdds";

const TAB_IDS = {
  FULL: "FULL",
  HALF: "HALF",
};

const hasData = (array) => Array.isArray(array) && array.length > 0;

export default function OkOtherBetsDropdown({
  goalOddEvenOdds,
  correctScoresOdds,
  totalCornersOdds,
  correctScoresHalfOdds,
  totalCornersHalfOdds,
  homeTeamName,
  awayTeamName,
}) {
  const [activeTab, setActiveTab] = useState(TAB_IDS.FULL);

  const CardWrapper = ({ title, firstHalfLabel, children }) => (
    <div className="card-content mb-3 rounded-xl border kbv-border-light bg-white kbv-shadow-subtle overflow-hidden">
      <div className="card-title flex items-center h-[58px] px-4 border-b kbv-border-light text-sm font-semibold kbv-text-darker kbv-shadow-main">
        <span className="flex items-center gap-2">
          {firstHalfLabel && (
            <span className="firstHalf rounded bg-green-600 px-2 py-0.5 text-xs font-semibold text-white kbv-bg-success">
              {firstHalfLabel}
            </span>
          )}
          <span>{title}</span>
        </span>
      </div>
      <div className="card-body pt-2.5 pr-2 pb-0 pl-[12.5px] md:px-7.5 md:pt-6 md:pb-0 rounded-b-xl bg-white mt-2">{children}</div>
    </div>
  );

  const renderFullTab = () => (
    <div className="space-y-3">
      {hasData(correctScoresOdds) && (
        <CardWrapper title="Tỷ Số Chính Xác">
          <OkCorrectScoresOdds
            correctScoresOdds={correctScoresOdds}
            homeTeamName={homeTeamName}
            awayTeamName={awayTeamName}
          />
        </CardWrapper>
      )}

      {hasData(goalOddEvenOdds) && (
        <CardWrapper title="Lẻ/Chẵn">
          <OKGoalOddEvenOdds goalOddEvenOdds={goalOddEvenOdds} />
        </CardWrapper>
      )}

      {hasData(totalCornersOdds) && (
        <CardWrapper title="Tổng Bàn Thắng">
          <OKTotalCornersOdds totalCornersOdds={totalCornersOdds} />
        </CardWrapper>
      )}
    </div>
  );

  const renderHalfTab = () => (
    <div className="space-y-3">
      {hasData(correctScoresHalfOdds) && (
        <CardWrapper title="Tỷ Số Chính Xác" firstHalfLabel="Hiệp Một">
          <OkCorrectScoresOdds
            correctScoresOdds={correctScoresHalfOdds}
            homeTeamName={homeTeamName}
            awayTeamName={awayTeamName}
          />
        </CardWrapper>
      )}

      {hasData(totalCornersHalfOdds) && (
        <CardWrapper title="Tổng Bàn Thắng" firstHalfLabel="Hiệp Một">
          <OKTotalCornersOdds totalCornersOdds={totalCornersHalfOdds} />
        </CardWrapper>
      )}
    </div>
  );

  return (
    <div className="w-full mx-auto mt-3">
      {/* Tabs */}
      <div className="mb-3 flex gap-2">
        <button
          type="button"
          onClick={() => setActiveTab(TAB_IDS.FULL)}
          className={`min-w-[96px] rounded-full px-4 py-1.5 text-sm font-semibold ${
            activeTab === TAB_IDS.FULL
              ? "bg-[var(--theme-primary)] text-[var(--theme-on-primary)]"
              : "bg-[var(--theme-foreground)] text-[var(--theme-text)] border border-[var(--theme-border)]"
          }`}
        >
          Cả trận
        </button>
        <button
          type="button"
          onClick={() => setActiveTab(TAB_IDS.HALF)}
          className={`min-w-[96px] rounded-full px-4 py-1.5 text-sm font-semibold ${
            activeTab === TAB_IDS.HALF
              ? "bg-[var(--theme-primary)] text-[var(--theme-on-primary)]"
              : "bg-[var(--theme-foreground)] text-[var(--theme-text)] border border-[var(--theme-border)]"
          }`}
        >
          Hiệp một
        </button>
      </div>

      {/* Content */}
      {activeTab === TAB_IDS.FULL ? renderFullTab() : renderHalfTab()}
    </div>
  );
}
